import React from 'react';
import { createRoot } from "react-dom/client";
import RedirectModalWrapper from "../components/RedirectModal/RedirectModalWrapper";

class RedirectModal {
  /**
   * @type { HTMLElement|null } The root element of the app.
   */
  app = null;
  pageId = -1;
  pageUrl= "";
  /**
   * @param { HTMLElement } app The root element of the app.
   */
  constructor(app) {
    this.app = app;
    const root = createRoot(app);
    this.pageId = this.app.dataset.page ? parseInt(this.app.dataset.page) : -1;
    this.pageUrl = this.app.dataset.permalink ?? "";
    root.render(<RedirectModalWrapper pageId={this.pageId} pageUrl={this.pageUrl} />);
  }
}

export default RedirectModal;
